import { Component, Input } from '@angular/core';

@Component({
  selector: 'evrideo-mark-in-icon',
  templateUrl: './mark-in-icon.component.html',
  styleUrls: ['./mark-in-icon.component.scss'],
})
export class MarkInIconComponent {
  @Input()
  overrideStyle: Record<string, string> = {};
}
